import SummitAttendeeAllocators from './SummitAttendeeAllocators'

export default SummitAttendeeAllocators
